import { Ability } from '@casl/ability'
import { initialAbility } from './config'

/**
 * Güvenli ability yönetimi
 * - localStorage'dan ability okur ama backend'den doğrular
 * - Token geçerliliğini kontrol eder
 * - Güvenlik açıklarını kapatır
 */

// Güvenli userData okuma fonksiyonu
function getSecureUserData() {
  try {
    const userData = localStorage.getItem('userData')
    const accessToken = localStorage.getItem('accessToken')
    
    // Token yoksa veya boşsa güvenli değil
    if (!accessToken || accessToken === 'undefined' || accessToken === 'null') {
      clearUserData()
      return null
    }
    
    // userData yoksa veya boşsa güvenli değil
    if (!userData || userData === 'undefined' || userData === 'null') {
      clearUserData()
      return null
    }
    
    const parsedUserData = JSON.parse(userData)
    
    // Ability yapısını doğrula
    if (!parsedUserData.ability || !Array.isArray(parsedUserData.ability)) {
      console.warn('Invalid ability structure detected, using initial ability')
      return { ability: initialAbility }
    }
    
    return parsedUserData
  } catch (error) {
    console.error('Error parsing user data:', error)
    clearUserData()
    return null
  }
}

// Güvenli veri temizleme fonksiyonu
function clearUserData() {
  localStorage.removeItem('userData')
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  // Sayfayı yenile ki kullanıcı login sayfasına yönlendirilsin
  if (window.location.pathname !== '/auth/login') {
    window.location.href = '/auth/login'
  }
}

// Token geçerliliğini kontrol et
function isTokenValid() {
  const accessToken = localStorage.getItem('accessToken')
  if (!accessToken) return false
  
  try {
    // JWT token'ı decode et (basit kontrol)
    const payload = JSON.parse(atob(accessToken.split('.')[1]))
    const currentTime = Math.floor(Date.now() / 1000)
    
    // Token süresi dolmuş mu?
    if (payload.exp && payload.exp < currentTime) {
      console.warn('Token expired, clearing user data')
      clearUserData()
      return false
    }
    
    return true
  } catch (error) {
    console.error('Invalid token format:', error)
    clearUserData()
    return false
  }
}

// Güvenli ability oluşturma
function createSecureAbility() {
  // Token geçerli mi kontrol et
  if (!isTokenValid()) {
    return new Ability(initialAbility)
  }
  
  // UserData'yı güvenli şekilde al
  const userData = getSecureUserData()
  if (!userData) {
    return new Ability(initialAbility)
  }
  
  // Ability'yi doğrula ve oluştur
  const ability = userData.ability || initialAbility
  return new Ability(ability)
}

// Güvenli ability instance'ı oluştur
const ability = createSecureAbility()

// Ability'yi güncelleme fonksiyonu (güvenli)
export function updateAbility(newAbility) {
  if (!isTokenValid()) {
    console.warn('Cannot update ability: Invalid token')
    return
  }
  
  if (!newAbility || !Array.isArray(newAbility)) {
    console.warn('Invalid ability structure provided')
    return
  }
  
  // Ability'yi güncelle
  ability.update(newAbility)
  
  // localStorage'ı güncelle (güvenlik için sadece geçerli token varsa)
  const userData = getSecureUserData()
  if (userData) {
    userData.ability = newAbility
    localStorage.setItem('userData', JSON.stringify(userData))
  }
}

// Ability'yi temizleme fonksiyonu
export function clearAbility() {
  clearUserData()
  ability.update(initialAbility)
}

export default ability
